module.exports = __webpack_public_path__ + "img/list03-sp.8ce1c240.png";